import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import {fetchList} from '@/api/gm/goods';
import { wait } from '@/utils/wait';
import {getAllAdminList} from "@/api/sms/arrival-order";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		category: {},
		adminList: []
	},
	actions: {
		async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'gm.goods.list', async function () {
				let { searchForm } = state;
				let params = {
					opAdminId: searchForm.opAdminId,
					goodsId: searchForm.goodsId,
					publishType: searchForm.publishType,
					suppName: searchForm.suppName,
					catId: searchForm.categoryLevel2 || searchForm.categoryLevel1 || searchForm.categoryLevel0
				}
				if(searchForm.shopId){
					params.shopIdList = [searchForm.shopId]
				}
				if(searchForm.select && searchForm.value){
					params[searchForm.select] = searchForm.value
				}
				if (searchForm.timeSelect && searchForm.timeValue) {
					params[searchForm.timeSelect] = {
						start: parseInt(searchForm.timeValue[0] / 1000),
						end: parseInt(searchForm.timeValue[1] / 1000)
					}
				}
				if (searchForm.amountStart && searchForm.amountEnd) {
					params.price = {
						start: searchForm.amountStart,
						end: searchForm.amountEnd
					}
				}
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...params,
						...payload
					}
				});
			})
		},
		async getAllAdminList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'oms.return-instock.all-admin', async function() {
				const response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						adminList: response.data.adminList
					})
				}
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/gm/goods/list.js